import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { departmentAction as actions, notificationActions } from '../actions';
import { DepartmentService } from '../services';

/* Add Department Sagas */
function* handleAddDepartmentRequest() {
  const action = yield take(actions.addDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.addDepartment, dataParams);
    if (res.isError) {
      yield put(actions.addDepartmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addDepartmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addDepartmentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get All Department Sagas*/
function* handleGetAllDepartmentRequest() {
  const action = yield take(actions.getAllDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAllDepartment, dataParams);

    if (res.isError) {
      yield put(actions.getAllDepartmentError(res));

    } else {
      yield put(actions.getAllDepartmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllDepartmentError());
  }
}

/* Get Department List Sagas*/
function* handleGetDepartmentListRequest() {
  const action = yield take(actions.getDepartmentListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getDepartmentList, dataParams);

    if (res.isError) {
      yield put(actions.getDepartmentListError(res));

    } else {
      yield put(actions.getDepartmentListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getDepartmentListError());
  }
}

/* Update Department Sagas */
function* handleUpdateDepartmentRequest() {
  const action = yield take(actions.updateDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.updateDepartment, dataParams);
    if (res.isError) {
      yield put(actions.updateDepartmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateDepartmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateDepartmentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Delete Department Sagas*/
function* handleDeleteDepartmentRequest() {
  const action = yield take(actions.deleteDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.deleteDepartment, dataParams);
    if (res.isError) {
      yield put(actions.deleteDepartmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteDepartmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteDepartmentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* create Sub Department Sagas */
function* handleCreateSubDepartmentRequest() {
  const action = yield take(actions.createSubDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.createSubDepartment, dataParams);
    if (res.isError) {
      yield put(actions.createSubDepartmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createSubDepartmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createSubDepartmentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Sub Department Sagas*/
function* handleGetSubDepartmentRequest() {
  const action = yield take(actions.getSubDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getSubDepartment, dataParams);

    if (res.isError) {
      yield put(actions.getSubDepartmentError(res));

    } else {
      yield put(actions.getSubDepartmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.getSubDepartmentError());
  }
}

/* Get All Sub Department List Sagas*/
function* handleGetAllSubDepartmentListRequest() {
  const action = yield take(actions.getAllSubDepartmentListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAllSubDepartmentList, dataParams);

    if (res.isError) {
      yield put(actions.getAllSubDepartmentListError(res));

    } else {
      yield put(actions.getAllSubDepartmentListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllSubDepartmentListError());
  }
}
/* Get Sub Department By Department Sagas*/
function* handleGetSubDepartmentByDepartmentRequest() {
  const action = yield take(actions.getSubDepartmentByDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getSubDepartmentByDepartment, dataParams);

    if (res.isError) {
      yield put(actions.getSubDepartmentByDepartmentError(res));

    } else {
      yield put(actions.getSubDepartmentByDepartmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.getSubDepartmentByDepartmentError());
  }
}

/* Update Sub Department Sagas */
function* handleUpdateSubDepartmentRequest() {
  const action = yield take(actions.updateSubDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.updateSubDepartment, dataParams);
    if (res.isError) {
      yield put(actions.updateSubDepartmentError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateSubDepartmentSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateSubDepartmentError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* create Sub Department Sagas */
function* handleCreateProjectRequest() {
  const action = yield take(actions.createProjectRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.createProject, dataParams);
    if (res.isError) {
      yield put(actions.createProjectError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createProjectSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createProjectError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Sub Department Sagas*/
function* handleGetProjectRequest() {
  const action = yield take(actions.getProjectRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getProject, dataParams);

    if (res.isError) {
      yield put(actions.getProjectError(res));

    } else {
      yield put(actions.getProjectSuccess(res));
    }

  } catch (error) {
    yield put(actions.getProjectError());
  }
}

/* Get All Sub Department List Sagas*/
function* handleGetAllProjectListRequest() {
  const action = yield take(actions.getAllProjectListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAllProjectList, dataParams);

    if (res.isError) {
      yield put(actions.getAllProjectListError(res));

    } else {
      yield put(actions.getAllProjectListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllProjectListError());
  }
}

/* Update Sub Department Sagas */
function* handleUpdateProjectRequest() {
  const action = yield take(actions.updateProjectRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.updateProject, dataParams);
    if (res.isError) {
      yield put(actions.updateProjectError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateProjectSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateProjectError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* create Sub Skill Sagas */
function* handleCreateSkillRequest() {
  const action = yield take(actions.createSkillRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.createSkill, dataParams);
    if (res.isError) {
      yield put(actions.createSkillError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createSkillSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.createSkillError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Sub Skill Sagas*/
function* handleGetSkillRequest() {
  const action = yield take(actions.getSkillRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getSkill, dataParams);

    if (res.isError) {
      yield put(actions.getSkillError(res));

    } else {
      yield put(actions.getSkillSuccess(res));
    }

  } catch (error) {
    yield put(actions.getSkillError());
  }
}

/* Get All Skill List Sagas*/
function* handleGetAllSkillListRequest() {
  const action = yield take(actions.getAllSkillListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAllSkillList, dataParams);

    if (res.isError) {
      yield put(actions.getAllSkillListError(res));

    } else {
      yield put(actions.getAllSkillListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllSkillListError());
  }
}

/* Update Skill Sagas */
function* handleUpdateSkillRequest() {
  const action = yield take(actions.updateSkillRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.updateSkill, dataParams);
    if (res.isError) {
      yield put(actions.updateSkillError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateSkillSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateSkillError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/*Assign Project Sagas */
function* handleAssignProjectRequest() {
  const action = yield take(actions.assignProjectRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.assignProject, dataParams);
    if (res.isError) {
      yield put(actions.assignProjectError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.assignProjectSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.assignProjectError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Assign Project Sagas*/
function* handleGetAssignProjectRequest() {
  const action = yield take(actions.getAssignProjectRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAssignProject, dataParams);

    if (res.isError) {
      yield put(actions.getAssignProjectError(res));

    } else {
      yield put(actions.getAssignProjectSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAssignProjectError());
  }
}

/* Assign Skill  Sagas */
function* handleAssignSkillRequest() {
  const action = yield take(actions.assignSkillRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.assignSkill, dataParams);
    if (res.isError) {
      yield put(actions.assignSkillError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.assignSkillSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.assignSkillError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Assign Skill Sagas*/
function* handleGetAssignSkillRequest() {
  const action = yield take(actions.getAssignSkillRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAssignSkill, dataParams);

    if (res.isError) {
      yield put(actions.getAssignSkillError(res));

    } else {
      yield put(actions.getAssignSkillSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAssignSkillError());
  }
}

/* Project Type */


/* create Sub Department Sagas */
function* handleAddProjectTypeRequest() {
  const action = yield take(actions.addProjectTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.addProjectType, dataParams);
    if (res.isError) {
      yield put(actions.addProjectTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addProjectTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addProjectTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Sub Department Sagas*/
function* handleGetProjectTypeRequest() {
  const action = yield take(actions.getProjectTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getProjectType, dataParams);

    if (res.isError) {
      yield put(actions.getProjectTypeError(res));

    } else {
      yield put(actions.getProjectTypeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getProjectTypeError());
  }
}

/* Get All Sub Department List Sagas*/
function* handleGetAllProjectTypeListRequest() {
  const action = yield take(actions.getAllProjectTypeListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAllProjectTypeList, dataParams);

    if (res.isError) {
      yield put(actions.getAllProjectTypeListError(res));

    } else {
      yield put(actions.getAllProjectTypeListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllProjectTypeListError());
  }
}

/* Update Sub Department Sagas */
function* handleUpdateProjectTypeRequest() {
  const action = yield take(actions.updateProjectTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.updateProjectType, dataParams);
    if (res.isError) {
      yield put(actions.updateProjectTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateProjectTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateProjectTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Update Sub Department Sagas */
function* handleDeleteProjectTypeRequest() {
  const action = yield take(actions.deleteProjectTypeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.deleteProjectType, dataParams);
    if (res.isError) {
      yield put(actions.deleteProjectTypeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteProjectTypeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteProjectTypeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Project category */


/* create Sub Department Sagas */
function* handleAddProjectCategoryRequest() {
  const action = yield take(actions.addProjectCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.addProjectCategory, dataParams);
    if (res.isError) {
      yield put(actions.addProjectCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.addProjectCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.addProjectCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Get Sub Department Sagas*/
function* handleGetProjectCategoryRequest() {
  const action = yield take(actions.getProjectCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getProjectCategory, dataParams);

    if (res.isError) {
      yield put(actions.getProjectCategoryError(res));

    } else {
      yield put(actions.getProjectCategorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getProjectCategoryError());
  }
}

/* Get All Sub Department List Sagas*/
function* handleGetAllProjectCategoryListRequest() {
  const action = yield take(actions.getAllProjectCategoryListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getAllProjectCategoryList, dataParams);

    if (res.isError) {
      yield put(actions.getAllProjectCategoryListError(res));

    } else {
      yield put(actions.getAllProjectCategoryListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllProjectCategoryListError());
  }
}

/* Update Sub Department Sagas */
function* handleUpdateProjectCategoryRequest() {
  const action = yield take(actions.updateProjectCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.updateProjectCategory, dataParams);
    if (res.isError) {
      yield put(actions.updateProjectCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.updateProjectCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.updateProjectCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* Update Sub Department Sagas */
function* handleDeleteProjectCategoryRequest() {
  const action = yield take(actions.deleteProjectCategoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.deleteProjectCategory, dataParams);
    if (res.isError) {
      yield put(actions.deleteProjectCategoryError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.deleteProjectCategorySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }
  } catch (error) {
    yield put(actions.deleteProjectCategoryError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Update Sub Department Sagas */
function* handleGetMastersCountsRequest() {
  const action = yield take(actions.getMastersCountsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(DepartmentService.getMastersCounts, dataParams);
    if (res.isError) {
      yield put(actions.getMastersCountsError(res));
      
    } else {
      yield put(actions.getMastersCountsSuccess(res));
      
    }
  } catch (error) {
    yield put(actions.getMastersCountsError());
   
  }
}


/* -----------Watchers------------- */
function* handleAddDepartmentWatcher() {
  yield takeEvery(
    actions.addDepartmentRequest,
    handleAddDepartmentRequest,
  );
}

function* handleGetDepartmentWatcher() {
  yield takeEvery(
    actions.getAllDepartmentRequest,
    handleGetAllDepartmentRequest,
  );
}

function* handleGetDepartmentListWatcher() {
  yield takeEvery(
    actions.getDepartmentListRequest,
    handleGetDepartmentListRequest,
  );
}

function* handleUpdateDepartmentWatcher() {
  yield takeEvery(
    actions.updateDepartmentRequest,
    handleUpdateDepartmentRequest,
  );
}

function* handleDeleteDepartmentWatcher() {
  yield takeEvery(
    actions.deleteDepartmentRequest,
    handleDeleteDepartmentRequest,
  );
}

function* handleCreateSubDepartmentWatcher() {
  yield takeEvery(
    actions.createSubDepartmentRequest,
    handleCreateSubDepartmentRequest,
  );
}

function* handleGetSubDepartmentWatcher() {
  yield takeEvery(
    actions.getSubDepartmentRequest,
    handleGetSubDepartmentRequest,
  );
}

function* handleGetAllSubDepartmentListWatcher() {
  yield takeEvery(
    actions.getAllSubDepartmentListRequest,
    handleGetAllSubDepartmentListRequest,
  );
}

function* handleGetSubDepartmentByDepartmentWatcher() {
  yield takeEvery(
    actions.getSubDepartmentByDepartmentRequest,
    handleGetSubDepartmentByDepartmentRequest,
  );
}


function* handleUpdateSubDepartmentWatcher() {
  yield takeEvery(
    actions.updateSubDepartmentRequest,
    handleUpdateSubDepartmentRequest,
  );
}

function* handleCreateProjectWatcher() {
  yield takeEvery(
    actions.createProjectRequest,
    handleCreateProjectRequest,
  );
}

function* handleGetProjectWatcher() {
  yield takeEvery(
    actions.getProjectRequest,
    handleGetProjectRequest,
  );
}

function* handleGetAllProjectListWatcher() {
  yield takeEvery(
    actions.getAllProjectListRequest,
    handleGetAllProjectListRequest,
  );
}

function* handleUpdateProjectWatcher() {
  yield takeEvery(
    actions.updateProjectRequest,
    handleUpdateProjectRequest,
  );
}
function* handleCreateSkillWatcher() {
  yield takeEvery(
    actions.createSkillRequest,
    handleCreateSkillRequest,
  );
}

function* handleGetSkillWatcher() {
  yield takeEvery(
    actions.getSkillRequest,
    handleGetSkillRequest,
  );
}

function* handleGetAllSkillListWatcher() {
  yield takeEvery(
    actions.getAllSkillListRequest,
    handleGetAllSkillListRequest,
  );
}

function* handleUpdateSkillWatcher() {
  yield takeEvery(
    actions.updateSkillRequest,
    handleUpdateSkillRequest,
  );
}

function* handleAssignProjectWatcher() {
  yield takeEvery(
    actions.assignProjectRequest,
    handleAssignProjectRequest,
  );
}

function* handleGetAssignProjectWatcher() {
  yield takeEvery(
    actions.getAssignProjectRequest,
    handleGetAssignProjectRequest,
  );
}

function* handleAssignSkillWatcher() {
  yield takeEvery(
    actions.assignSkillRequest,
    handleAssignSkillRequest,
  );
}

function* handleGetAssignSkillWatcher() {
  yield takeEvery(
    actions.getAssignSkillRequest,
    handleGetAssignSkillRequest,
  );
}


function* handleAddProjectTypeWatcher() {
  yield takeEvery(
    actions.addProjectTypeRequest,
    handleAddProjectTypeRequest,
  );
}

function* handleGetProjectTypeWatcher() {
  yield takeEvery(
    actions.getProjectTypeRequest,
    handleGetProjectTypeRequest,
  );
}

function* handleGetAllProjectTypeListWatcher() {
  yield takeEvery(
    actions.getAllProjectTypeListRequest,
    handleGetAllProjectTypeListRequest,
  );
}

function* handleUpdateProjectTypeWatcher() {
  yield takeEvery(
    actions.updateProjectTypeRequest,
    handleUpdateProjectTypeRequest,
  );
}

function* handleDeleteProjectTypeWatcher() {
  yield takeEvery(
    actions.deleteProjectTypeRequest,
    handleDeleteProjectTypeRequest,
  );
}


function* handleAddProjectCategoryWatcher() {
  yield takeEvery(
    actions.addProjectCategoryRequest,
    handleAddProjectCategoryRequest,
  );
}

function* handleGetProjectCategoryWatcher() {
  yield takeEvery(
    actions.getProjectCategoryRequest,
    handleGetProjectCategoryRequest,
  );
}

function* handleGetAllProjectCategoryListWatcher() {
  yield takeEvery(
    actions.getAllProjectCategoryListRequest,
    handleGetAllProjectCategoryListRequest,
  );
}

function* handleUpdateProjectCategoryWatcher() {
  yield takeEvery(
    actions.updateProjectCategoryRequest,
    handleUpdateProjectCategoryRequest,
  );
}

function* handleDeleteProjectCategoryWatcher() {
  yield takeEvery(
    actions.deleteProjectCategoryRequest,
    handleDeleteProjectCategoryRequest,
  );
}


function* handleGetMastersCountsWatcher() {
  yield takeEvery(
    actions.getMastersCountsRequest,
    handleGetMastersCountsRequest,
  );
}


function* rootDepartmentSaga() {
  yield all([
    handleAddDepartmentRequest(),
    handleAddDepartmentWatcher(),

    handleGetAllDepartmentRequest(),
    handleGetDepartmentWatcher(),

    handleGetDepartmentListRequest(),
    handleGetDepartmentListWatcher(),

    handleUpdateDepartmentRequest(),
    handleUpdateDepartmentWatcher(),

    handleDeleteDepartmentRequest(),
    handleDeleteDepartmentWatcher(),

    handleCreateSubDepartmentRequest(),
    handleCreateSubDepartmentWatcher(),

    handleGetSubDepartmentRequest(),
    handleGetSubDepartmentWatcher(),

    handleGetAllSubDepartmentListRequest(),
    handleGetAllSubDepartmentListWatcher(),

    handleGetSubDepartmentByDepartmentRequest(),
    handleGetSubDepartmentByDepartmentWatcher(),

    handleUpdateSubDepartmentRequest(),
    handleUpdateSubDepartmentWatcher(),

    handleCreateProjectRequest(),
    handleCreateProjectWatcher(),

    handleGetProjectRequest(),
    handleGetProjectWatcher(),

    handleGetAllProjectListRequest(),
    handleGetAllProjectListWatcher(),

    handleUpdateProjectRequest(),
    handleUpdateProjectWatcher(),

    handleCreateSkillRequest(),
    handleCreateSkillWatcher(),

    handleGetSkillRequest(),
    handleGetSkillWatcher(),

    handleGetAllSkillListRequest(),
    handleGetAllSkillListWatcher(),

    handleUpdateSkillRequest(),
    handleUpdateSkillWatcher(),

    handleAssignProjectRequest(),
    handleAssignProjectWatcher(),

    handleGetAssignProjectRequest(),
    handleGetAssignProjectWatcher(),

    handleAssignSkillRequest(),
    handleAssignSkillWatcher(),

    handleGetAssignSkillRequest(),
    handleGetAssignSkillWatcher(),

    handleAddProjectTypeRequest(),
    handleAddProjectTypeWatcher(),

    handleGetProjectTypeRequest(),
    handleGetProjectTypeWatcher(),

    handleGetAllProjectTypeListRequest(),
    handleGetAllProjectTypeListWatcher(),

    handleUpdateProjectTypeRequest(),
    handleUpdateProjectTypeWatcher(),

    handleDeleteProjectTypeRequest(),
    handleDeleteProjectTypeWatcher(),

    handleAddProjectCategoryRequest(),
    handleAddProjectCategoryWatcher(),

    handleGetProjectCategoryRequest(),
    handleGetProjectCategoryWatcher(),

    handleGetAllProjectCategoryListRequest(),
    handleGetAllProjectCategoryListWatcher(),

    handleUpdateProjectCategoryRequest(),
    handleUpdateProjectCategoryWatcher(),

    handleDeleteProjectCategoryRequest(),
    handleDeleteProjectCategoryWatcher(),

    handleGetMastersCountsRequest(),
    handleGetMastersCountsWatcher(),
  ]);
}

export default rootDepartmentSaga;
